import { defaultOptions as n } from "./index25.mjs";
import { initReactI18next as s } from "./index80.mjs";
const e = (t, i) => (t.use(s).init({
  ...n,
  ...i
}), {
  i18n: t
});
export {
  e as initI18nInstance
};
